import getKeyboardShortcutsOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('discardKeyboardShortcutsOption', function discardKeyboardShortcutsOption() {
    var optionState = getKeyboardShortcutsOptions();
    optionState.shortcuts = null;
});
//# sourceMappingURL=discardKeyboardShortcutsOption.js.map